/**
 * @classdesc German Language Pack
 * @desc This class will used to translate tokens into the German language.
 * @namespace Languages.German
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.German
 */
export const dictionary = {
	'years'   : 'Jahre',
	'months'  : 'Monate',
	'days'    : 'Tage',
	'hours'   : 'Stunden',
	'minutes' : 'Minuten',
	'seconds' : 'Sekunden'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.German
 */
export const aliases = ['de', 'de-de', 'german'];
